/* eslint radix: ["off"] */

import React, {Component, Fragment} from 'react';
import { inject, observer } from 'mobx-react';
import { withWindowSize } from 'air-with-window-size';
import TripItem from "../TripItem";
import AirList from "../../../../common/components/AirList";
import TripDetail from "../TripDetail";
import FiltersBar from "../FiltersBar";

@inject('translationsStore', 'tripsStore')
@observer
class TripsList extends Component {
  constructor(props) {
    super(props);

    this.state = { pageSize: undefined };
  }

  updatePageSize() {
    let deltaHeight = this.props.windowHeight - 800;
    if (deltaHeight < 0) {
      deltaHeight = deltaHeight + 48;
    }

    const pageSize = 3 + Math.floor(deltaHeight / 189);
    if (pageSize !== this.state.pageSize) {
      this.setState({ pageSize: pageSize }, () => {
        this.props.tripsStore.changePage(1, pageSize);
      });
    }
  }

  componentDidMount = () => {
    this.props.tripsStore.clearFilters();
    this.updatePageSize();
  };

  componentDidUpdate = (prevProps, prevState) => {
    if (prevProps.windowHeight !== this.props.windowHeight) {
      this.updatePageSize();
    }
  };

  onPageChange = page => {
    this.props.tripsStore.changePage(page, this.state.pageSize);
  };

  render() {
    const { tripsStore, translationsStore } = this.props;
    const { pageSize } = this.state;

    if (tripsStore.selectedDetailTrip) {
      return <TripDetail trip={tripsStore.selectedDetailTrip} />;
    }

    return (
      <Fragment>
        <FiltersBar />
        {pageSize && (
          <AirList
            paginationPosition="bottom"
            pageSize={pageSize}
            dataSource={tripsStore.trips || []}
            renderItem={item => <TripItem key={item.id} trip={item} />}
            currentPage={tripsStore.page}
            onPageChange={this.onPageChange}
            total={tripsStore.tripsCount}
            itemName={translationsStore.translate('tripsList.pagination.label')}
          />
        )}
      </Fragment>
    );
  }
}

export default withWindowSize(TripsList);



// WEBPACK FOOTER //
// ./src/components/App/Trips/TripsList/TripsList.js